(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["split-hero-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.shcReady) return;
      root.dataset.shcReady = '1';

      var track = root.querySelector('[data-shc-track]');
      var slides = root.querySelectorAll('.shc__slide');
      if (!track || slides.length < 2) return;

      var n = slides.length;
      var dots = root.querySelectorAll('[data-shc-dot]');
      var prev = root.querySelector('[data-shc-prev]');
      var next = root.querySelector('[data-shc-next]');
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var designMode = window.Shopify && window.Shopify.designMode;
      var autoplay = root.dataset.autoplay === 'true' && !reduce && !designMode;
      var delay = (parseInt(root.dataset.speed, 10) || 7) * 1000;
      var index = 0;
      var timer = null;
      var ticking = false;
      var settleTimer = null;

      // Bucle infinito: copia de la ultima al principio y de la primera al final.
      // Al llegar a una copia, se salta (sin animacion) a la diapositiva real equivalente.
      function makeClone(src) {
        var c = src.cloneNode(true);
        c.setAttribute('data-shc-clone', '');
        c.setAttribute('aria-hidden', 'true');
        c.removeAttribute('data-shopify-editor-block');
        c.removeAttribute('role');
        c.removeAttribute('aria-label');
        c.setAttribute('inert', '');
        var ids = c.querySelectorAll('[id]');
        for (var k = 0; k < ids.length; k++) ids[k].removeAttribute('id');
        var focusables = c.querySelectorAll('a, button');
        for (var f = 0; f < focusables.length; f++) focusables[f].setAttribute('tabindex', '-1');
        return c;
      }
      track.insertBefore(makeClone(slides[n - 1]), slides[0]);
      track.appendChild(makeClone(slides[0]));

      function width() { return track.clientWidth; }

      function jump(pos) {
        track.style.scrollSnapType = 'none';
        track.scrollLeft = pos * width();
        void track.offsetWidth;
        track.style.scrollSnapType = '';
      }

      function go(i) {
        // i puede valer -1 (copia de la ultima) o n (copia de la primera)
        index = ((i % n) + n) % n;
        track.scrollTo({ left: (i + 1) * width(), behavior: reduce ? 'auto' : 'smooth' });
        if (reduce) settle();
      }

      function setActive(i) {
        index = i;
        for (var d = 0; d < dots.length; d++) {
          if (d === i) dots[d].setAttribute('aria-current', 'true');
          else dots[d].removeAttribute('aria-current');
        }
      }

      function currentPos() { return Math.round(track.scrollLeft / width()); }

      function settle() {
        var pos = currentPos();
        if (pos === 0) jump(n);
        else if (pos === n + 1) jump(1);
      }

      function start() {
        if (!autoplay || timer) return;
        timer = setInterval(function () { go(index + 1); }, delay);
      }
      function stop() {
        if (timer) { clearInterval(timer); timer = null; }
      }

      track.addEventListener('scroll', function () {
        if (!ticking) {
          ticking = true;
          requestAnimationFrame(function () {
            setActive((((currentPos() - 1) % n) + n) % n);
            ticking = false;
          });
        }
        clearTimeout(settleTimer);
        settleTimer = setTimeout(settle, 110);
      }, { passive: true });

      if (prev) prev.addEventListener('click', function () { go(index - 1); });
      if (next) next.addEventListener('click', function () { go(index + 1); });
      for (var d = 0; d < dots.length; d++) {
        (function (n) { dots[n].addEventListener('click', function () { go(n); }); })(d);
      }

      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
      root.addEventListener('focusin', stop);
      root.addEventListener('focusout', start);
      root.addEventListener('touchstart', stop, { passive: true });
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) stop(); else start();
      });
      window.addEventListener('resize', function () {
        jump(index + 1);
      });

      // Diapositiva inicial: primera, aleatoria o rotando cada hora
      var mode = root.dataset.start || 'first';
      var startAt = 0;
      if (!designMode) {
        if (mode === 'random') startAt = Math.floor(Math.random() * n);
        else if (mode === 'hourly') startAt = Math.floor(Date.now() / 3600000) % n;
      }
      setActive(startAt);
      jump(startAt + 1);
      root.classList.add('shc--ready');

      // Videos de fondo: solo se reproducen los que se ven (ahorra datos y bateria);
      // con movimiento reducido se quedan quietos mostrando la imagen
      var vids = root.querySelectorAll('video');
      // En movil (hasta 700 px) se ve la foto en lugar del video, asi que no se reproduce ni se descarga
      if (window.matchMedia('(max-width: 700px)').matches) {
        for (var mv = 0; mv < vids.length; mv++) {
          var mvid = vids[mv];
          mvid.removeAttribute('autoplay'); mvid.pause();
          if (mvid.classList.contains('shc__video--has-still')) {
            while (mvid.firstChild) mvid.removeChild(mvid.firstChild);
            mvid.removeAttribute('poster'); mvid.load();
          }
        }
        vids = [];
      }
      if (vids.length) {
        for (var v = 0; v < vids.length; v++) { vids[v].muted = true; vids[v].setAttribute('playsinline', ''); }
        if (reduce) {
          for (var r = 0; r < vids.length; r++) { vids[r].removeAttribute('autoplay'); vids[r].pause(); }
        } else if ('IntersectionObserver' in window) {
          var visible = new Set();
          var tryPlay = function (vd) { var pr = vd.play(); if (pr && pr.catch) pr.catch(function () {}); };
          var io = new IntersectionObserver(function (entries) {
            entries.forEach(function (en) {
              var vd = en.target;
              if (en.isIntersecting) { visible.add(vd); tryPlay(vd); }
              else { visible.delete(vd); vd.pause(); }
            });
          }, { threshold: 0.25 });
          for (var o = 0; o < vids.length; o++) {
            io.observe(vids[o]);
            // En movil el navegador a veces rechaza el primer play(): se reintenta al cargar el video
            vids[o].addEventListener('loadeddata', function () { if (visible.has(this)) tryPlay(this); });
            vids[o].addEventListener('canplay', function () { if (visible.has(this)) tryPlay(this); });
          }
          // Y con el primer toque o scroll (el modo de bajo consumo de iPhone bloquea el autoplay hasta que hay interaccion)
          var kick = function () { visible.forEach(function (vd) { if (vd.paused) tryPlay(vd); }); };
          ['touchstart', 'pointerdown', 'scroll'].forEach(function (ev) { window.addEventListener(ev, kick, { passive: true, once: true }); });
          document.addEventListener('visibilitychange', function () { if (!document.hidden) kick(); });
        }
      }
      root._shcGo = go;
      root._shcStop = stop;
      start();
    }

    function initAll() {
      var roots = document.querySelectorAll('[data-shc]');
      for (var i = 0; i < roots.length; i++) init(roots[i]);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
    else initAll();

    // Editor de temas: reiniciar al editar la seccion y saltar a la diapositiva seleccionada
    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target.querySelector('[data-shc]');
      if (root) init(root);
    });
    document.addEventListener('shopify:block:select', function (e) {
      var root = e.target.closest('[data-shc]');
      if (!root || !root._shcGo) return;
      var slides = root.querySelectorAll('.shc__slide:not([data-shc-clone])');
      for (var i = 0; i < slides.length; i++) {
        if (slides[i] === e.target) { root._shcStop(); root._shcGo(i); break; }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
